module.exports = __webpack_public_path__ + "static/media/hide.f4cc5b23.svg";